// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"navbar_menuBar__2j0un","title":"navbar_title__3Q_m-","actions":"navbar_actions__2czzD","actionsItems":"navbar_actionsItems__16yGN"};